import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loader"]

  connect() {
    this.loading = false
    this.createObserver()
    this.observeLoader()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  loaderTargetConnected() {
    this.loading = false

    if (!this.observer) {
      this.createObserver()
    }

    this.observeLoader()
  }

  createObserver() {
    this.observer?.disconnect()

    this.observer = new IntersectionObserver(
      entries => {
        if (entries[0]?.isIntersecting) this.loadNext()
      },
      {
        root: this.element,
        rootMargin: "2000px 0px",
        threshold: 0
      }
    )
  }

  observeLoader() {
    if (!this.observer || !this.hasLoaderTarget) return

    this.observer.disconnect()
    this.createObserver()
    this.observer.observe(this.loaderTarget)
  }

  async loadNext() {
    if (this.loading || !this.hasLoaderTarget) return

    const url = this.loaderTarget.dataset.url
    if (!url) return

    this.loading = true
    this.observer?.unobserve(this.loaderTarget)

    try {
      const response = await fetch(url, {
        headers: { Accept: "text/vnd.turbo-stream.html" }
      })

      if (!response.ok) throw new Error("Pagination failed")

      const html = await response.text()
      Turbo.renderStreamMessage(html)
    } catch (error) {
      console.error(error)
      this.loading = false
      this.observeLoader()
    }
  }
}